import * as bus from "@sinch/bus";
import { useEffect } from "react";
import { EVENT_NAME } from "../analytics/createRudderstackEvent";
import { APP_NAME } from "../renderShell";
import { useNavigationEffect } from "./useNavigationEffect";

type UsePageViewEventGenerator = (isListenerSet: boolean) => void;

export const usePageViewEventGenerator: UsePageViewEventGenerator = (
  isListenerSet
) => {
  useEffect(() => {
    if (isListenerSet) {
      bus.sendTrackEvent({
        name: EVENT_NAME.PAGE_LOADED,
        appName: APP_NAME,
        purposes: ["Analytical"],
      });
    }
  }, [isListenerSet]);

  useNavigationEffect(() => {
    if (isListenerSet) {
      bus.sendTrackEvent({
        name: EVENT_NAME.PAGE_LOADED,
        appName: APP_NAME,
        purposes: ["Analytical"],
      });
    }
  }, [isListenerSet]);
};
